module.exports = __webpack_public_path__ + "static/media/37.4af6a976.jpg";